import {
  blue,
  blueGrey,
  cyan,
  deepOrange,
  green,
  grey,
  indigo,
  lightBlue,
  lightGreen,
  orange,
  purple,
  red,
  teal,
} from '@mui/material/colors';
import { ItemSourceEnum } from '../types/marketplace';
import { IReportStatusMapper, ReportSourceTypesEnum } from '../types/reports';
import variables from '../_variables.scss';

import {
  ANNIVERSARY_CAMPAIGN,
  AWAITING_ADDRESS,
  AWAITING_SHIPMENT,
  BIRTHDAY_CAMPAIGN,
  BULK,
  CANCELED,
  COMPLETED,
  DELIVERED,
  DIRECT,
  EMAIL_BLOCKED,
  EMAIL_BOUNCED,
  EMAIL_DELIVERED,
  EMAIL_OPENED,
  EMAIL_QUEUED,
  EMAIL_REJECTED,
  EMAIL_SENT,
  EXPIRED,
  FAILED,
  GIFT_CLAIMED,
  HUBSPOT,
  IN_FULFILLMENT,
  NEW,
  NEW_HIRE_CAMPAIGN,
  ONE_LINK,
  PAYMENT_PENDING,
  PROCESSING,
  PROCESSING_ORDER,
  SHIPPED,
  SINGLE,
  VIEWED,
  WEBHOOK,
  ZAPIER,
} from './reportsKeys';

export * from './reportsKeys';

export const REPORT_STATUS: IReportStatusMapper = {
  [AWAITING_ADDRESS]: {
    label: 'Awaiting address',
    color: blue[300],
  },
  [VIEWED]: {
    label: 'Viewed',
    color: indigo[300],
  },
  [AWAITING_SHIPMENT]: {
    label: 'Production',
    color: orange[300],
  },
  [IN_FULFILLMENT]: {
    label: 'Fulfillment',
    color: teal[300],
  },
  [SHIPPED]: {
    label: 'Transit',
    color: cyan[300],
  },
  [DELIVERED]: {
    label: 'Delivered',
    color: green[300],
  },
  [COMPLETED]: {
    label: 'Completed',
    color: green[800],
  },
  [EXPIRED]: {
    label: 'Expired',
    color: red[200],
  },
  [PROCESSING]: {
    label: 'Processing',
    color: grey[400],
  },
  [CANCELED]: {
    label: 'Canceled',
    color: grey[400],
  },
  [FAILED]: {
    label: 'Failed',
    color: variables.errorRed,
  },
  [GIFT_CLAIMED]: {
    label: 'Gift claimed',
    color: teal[200],
  },
  [EMAIL_SENT]: {
    label: 'Email sent',
    color: blue[200],
  },
  [EMAIL_DELIVERED]: {
    label: 'Email delivered',
    color: green[200],
  },
  [NEW]: {
    label: NEW,
    color: blueGrey[100],
  },
  [PAYMENT_PENDING]: {
    label: 'Payment pending',
    color: blueGrey[300],
  },
  [PROCESSING_ORDER]: {
    label: 'Processing order',
    color: blueGrey[300],
  },
  [EMAIL_REJECTED]: {
    label: 'Email rejected',
    color: blueGrey[300],
  },
  [EMAIL_BOUNCED]: {
    label: 'Email bounced',
    color: blueGrey[300],
  },
  [EMAIL_QUEUED]: {
    label: 'Email queued',
    color: blueGrey[300],
  },
  [EMAIL_OPENED]: {
    label: 'Email opened',
    color: blueGrey[300],
  },
  [EMAIL_BLOCKED]: {
    label: 'Email blocked',
    color: blueGrey[300],
  },
};

export const COLUMN_IDS = {
  ORDER_ID: 'order_id',
  STATUS: 'status',
  CAMPAIGN_NAME: 'campaign_name',
  SEND_TYPE: 'send_type',
  ITEM_SOURCE: 'item_source',
  GIFT_BUDGET: 'gift_budget',
  CREATED_BY: 'created_by',
  SENDER: 'sender',
  RECEIVER: 'receiver',
  WAREHOUSE: 'warehouse',
  CREATED_DATE: 'created_date',
  EXPIRATION_DATE: 'expiration_date',
  SHIPMENT_ID: 'shipment_id',
  TRACKING_NUMBER: 'tracking_number',
  COURIER: 'courier',
  CLAIM_LINK: 'claim_link',
  TRACKING_URL: 'tracking_url',
  VIEW_DATE: 'view_date',
  SHIPPED_DATE: 'shipped_date',
  SUBMITTED_DATE: 'submitted_date',
  DELIVERED_DATE: 'delivered_date',
  ACTIONS: 'actions',
};

export const SEND_TYPES = [
  {
    title: SINGLE,
    value: ReportSourceTypesEnum.Single,
    color: variables.sendTypeSingle,
    backgroundColor: lightGreen[50],
  },
  {
    title: DIRECT,
    value: ReportSourceTypesEnum.Direct,
    color: variables.sendTypeDirect,
    backgroundColor: indigo[50],
  },
  {
    title: BULK,
    value: ReportSourceTypesEnum.Bulk,
    color: variables.sendTypeBulk,
    backgroundColor: lightBlue[50],
  },
  {
    title: ONE_LINK,
    value: ReportSourceTypesEnum.OneLink,
    color: variables.sendTypeOnelink,
    backgroundColor: purple[50],
  },
  {
    title: ZAPIER,
    value: ReportSourceTypesEnum.Zapier,
    color: variables.integrationOrange,
    backgroundColor: orange[50],
  },
  {
    title: WEBHOOK,
    value: ReportSourceTypesEnum.Webhook,
    color: variables.sendTypeWebhook,
    backgroundColor: purple[50],
  },
  {
    title: NEW_HIRE_CAMPAIGN,
    value: ReportSourceTypesEnum.NewHireCampaign,
    color: green[800],
    backgroundColor: green[50],
  },
  {
    title: BIRTHDAY_CAMPAIGN,
    value: ReportSourceTypesEnum.BirthdayCampaign,
    color: variables.sendTypeBirthday,
    backgroundColor: deepOrange[50],
  },
  {
    title: ANNIVERSARY_CAMPAIGN,
    value: ReportSourceTypesEnum.AnniversaryCampaign,
    color: variables.sendTypeAnniversary,
    backgroundColor: cyan[50],
  },
  {
    title: HUBSPOT,
    value: ReportSourceTypesEnum.HubSpot,
    color: variables.integrationOrange,
    backgroundColor: orange[50],
  },
];

export const REGULAR_SEND_STATUSES = [
  { label: REPORT_STATUS[AWAITING_ADDRESS].label, value: AWAITING_ADDRESS },
  { label: REPORT_STATUS[VIEWED].label, value: VIEWED },
  { label: REPORT_STATUS[AWAITING_SHIPMENT].label, value: AWAITING_SHIPMENT },
  { label: REPORT_STATUS[IN_FULFILLMENT].label, value: IN_FULFILLMENT },
  { label: REPORT_STATUS[SHIPPED].label, value: SHIPPED },
  { label: REPORT_STATUS[DELIVERED].label, value: DELIVERED },
  { label: REPORT_STATUS[COMPLETED].label, value: COMPLETED },
  { label: REPORT_STATUS[EXPIRED].label, value: EXPIRED },
  { label: REPORT_STATUS[PROCESSING].label, value: PROCESSING },
  { label: REPORT_STATUS[CANCELED].label, value: CANCELED },
  { label: REPORT_STATUS[GIFT_CLAIMED].label, value: GIFT_CLAIMED },
  { label: REPORT_STATUS[EMAIL_SENT].label, value: EMAIL_SENT },
  { label: REPORT_STATUS[EMAIL_DELIVERED].label, value: EMAIL_DELIVERED },
  { label: REPORT_STATUS[NEW].label, value: NEW },
];

export const SCHEDULED_SEND_STATUSES = [
  { label: REPORT_STATUS[FAILED].label, value: FAILED },
  { label: REPORT_STATUS[AWAITING_ADDRESS].label, value: AWAITING_ADDRESS },
  { label: REPORT_STATUS[PROCESSING].label, value: PROCESSING },
];

export const VISIBLE_REPORTS_COLS_INITIAL_STATE = {
  [COLUMN_IDS.ORDER_ID]: true,
  [COLUMN_IDS.STATUS]: true,
  [COLUMN_IDS.CAMPAIGN_NAME]: true,
  [COLUMN_IDS.SEND_TYPE]: true,
  [COLUMN_IDS.ITEM_SOURCE]: true,
  [COLUMN_IDS.GIFT_BUDGET]: true,
  [COLUMN_IDS.CREATED_BY]: true,
  [COLUMN_IDS.SENDER]: true,
  [COLUMN_IDS.RECEIVER]: true,
  [COLUMN_IDS.WAREHOUSE]: true,
  [COLUMN_IDS.CREATED_DATE]: true,
  [COLUMN_IDS.EXPIRATION_DATE]: true,
  [COLUMN_IDS.SHIPMENT_ID]: true,
  [COLUMN_IDS.CLAIM_LINK]: true,
  [COLUMN_IDS.TRACKING_URL]: true,
  [COLUMN_IDS.ACTIONS]: true,
  [COLUMN_IDS.TRACKING_NUMBER]: false,
  [COLUMN_IDS.COURIER]: false,
  [COLUMN_IDS.VIEW_DATE]: false,
  [COLUMN_IDS.SHIPPED_DATE]: false,
  [COLUMN_IDS.SUBMITTED_DATE]: false,
  [COLUMN_IDS.DELIVERED_DATE]: false,
};

export const ITEM_SOURCE_LABEL: Record<ItemSourceEnum, string> = {
  [ItemSourceEnum.IeWarehouse]: 'Your inventory',
  [ItemSourceEnum.Marketplace]: 'Marketplace',
};

export const ITEM_SOURCE_COMBINED_LABEL: Record<ItemSourceEnum, string> = {
  [ItemSourceEnum.IeWarehouse]: 'Inventory',
  [ItemSourceEnum.Marketplace]: 'Marketplace',
};

export const ITEM_SOURCE_ORDER: ItemSourceEnum[] = [ItemSourceEnum.IeWarehouse, ItemSourceEnum.Marketplace];

export const ITEM_SOURCE_NOTE: Record<ItemSourceEnum, string> = {
  [ItemSourceEnum.IeWarehouse]: '',
  [ItemSourceEnum.Marketplace]: 'Fulfilled by Modern Dropship',
};

export const ITEM_SOURCE_NOTE_SEPARATOR = ' · ';

export const MARKETPLACE_CAMPAIGN_LABEL = 'Marketplace selection';

export const PICK_YOUR_GIFT_LABEL = 'Pick your gift';

export const MODERN_DROPSHIP_ORDER_NOTE = 'Modern Dropship order';

export const GIFT_BUDGET_NOT_USED_LABEL = 'Not used';

export const GIFT_BUDGET_SPENT_SUFFIX = 'spent';

export const GIFT_BUDGET_REMAINING_SUFFIX = 'remaining';

export const GIFT_BUDGET_SPENT_OF_SEPARATOR = 'spent of';

export const GIFT_BUDGET_SUMMARY_LABEL = 'Gift budget';

export const GIFT_BUDGET_SUMMARY_TOOLTIP = 'The full budget is charged when the send is created';

export const GIFT_BUDGET_SUMMARY_NOT_USED = 'Not used — picked from your inventory';

export const GIFT_BUDGET_INLINE_SEPARATOR = '—';

export const GIFT_BUDGET_NOT_USED_INLINE_LABEL = 'not used';
